import { DeliveryMapBounds } from './deliveryMapTypes';

const LONGITUDE_SPAN = 360;
const MAX_LONGITUDE = 180;
const MAX_LATITUDE = 90;

function wrapLongitude(longitude: number): number {
  return ((longitude + MAX_LONGITUDE) % LONGITUDE_SPAN + LONGITUDE_SPAN) % LONGITUDE_SPAN - MAX_LONGITUDE;
}

export function normalizeDeliveryMapBounds(bounds: DeliveryMapBounds): DeliveryMapBounds | null {
  const values = Object.values(bounds);
  if (!values.every(Number.isFinite)) return null;
  const south = Math.max(-MAX_LATITUDE, Math.min(MAX_LATITUDE, bounds.south));
  const north = Math.max(-MAX_LATITUDE, Math.min(MAX_LATITUDE, bounds.north));
  if (south >= north || bounds.east === bounds.west) return null;
  if (Math.abs(bounds.east - bounds.west) >= LONGITUDE_SPAN) {
    return { west: -MAX_LONGITUDE, south, east: MAX_LONGITUDE, north };
  }
  const west = wrapLongitude(bounds.west);
  const east = wrapLongitude(bounds.east);
  return { west, south, east, north };
}
